import { pdfjs } from "react-pdf";
import { PDFDocument } from "pdf-lib";

const DEFAULT_MAX_BYTES = 950 * 1024;

const ATTEMPTS = [
  { scale: 1.6, quality: 0.72 },
  { scale: 1.3, quality: 0.65 },
  { scale: 1.1, quality: 0.55 },
  { scale: 0.9, quality: 0.5 },
];

const base64Of = (dataUrl) =>
  dataUrl.includes(",") ? dataUrl.split(",")[1] : dataUrl;

const toUint8 = (dataUrl) => {
  const bin = atob(base64Of(dataUrl));
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return arr;
};

const uint8ToBase64 = (bytes) => {
  let bin = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    bin += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return btoa(bin);
};

const rebuild = async (doc, scale, quality) => {
  const out = await PDFDocument.create();
  for (let n = 1; n <= doc.numPages; n++) {
    const page = await doc.getPage(n);
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement("canvas");
    canvas.width = Math.ceil(viewport.width);
    canvas.height = Math.ceil(viewport.height);
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    await page.render({ canvasContext: ctx, viewport }).promise;
    const jpg = canvas.toDataURL("image/jpeg", quality);
    const img = await out.embedJpg(jpg);
    const p = out.addPage([canvas.width, canvas.height]);
    p.drawImage(img, { x: 0, y: 0, width: canvas.width, height: canvas.height });
  }
  const bytes = await out.save();
  return `data:application/pdf;base64,${uint8ToBase64(bytes)}`;
};

export const compressPdf = async (pdfDataUrl, maxBytes = DEFAULT_MAX_BYTES) => {
  const doc = await pdfjs.getDocument({ data: toUint8(pdfDataUrl) }).promise;
  let best = pdfDataUrl;
  for (const { scale, quality } of ATTEMPTS) {
    const candidate = await rebuild(doc, scale, quality);
    best = candidate;
    if (base64Of(candidate).length <= maxBytes) break;
  }
  return best;
};

export const compressPdfIfNeeded = async (
  pdfDataUrl,
  maxBytes = DEFAULT_MAX_BYTES
) => {
  if (base64Of(pdfDataUrl).length <= maxBytes) return pdfDataUrl;
  return compressPdf(pdfDataUrl, maxBytes);
};
